<template>
  <b-card title="Új megrendelő">
    <b-row>
      <b-col md="6">
        <b-form-group
          label="Cégnév"
          label-for="company_name"
        >
          <b-form-input
            id="company_name"
            v-model="company_name"
            placeholder="Cégnév"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
          label="Telefonszám"
          label-for="phone"
        >
          <b-form-input
            id="phone"
            v-model="phone"
            placeholder="Telefonszám"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
          label="Kapcsolattartó neve"
          label-for="contact_name"
        >
          <b-form-input
            id="contact_name"
            v-model="contact_name"
            placeholder="Kapcsolattartó neve"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <hr>
    <h5>Céges logó</h5>
    <small class="text-muted d-block mb-1">Az ajánlatok borítóján megjelenő logó (JPG, PNG, max 4 MB)</small>

    <div
      v-if="logo_preview"
      class="mb-2"
    >
      <img
        :src="logo_preview"
        alt="Logó előnézet"
        style="max-height: 80px; max-width: 300px; object-fit: contain; border: 1px solid #ddd; border-radius: 4px; padding: 6px; background: #fff;"
      >
    </div>

    <b-form-file
      v-model="logo_file"
      accept="image/*"
      placeholder="Válassz képfájlt..."
      browse-text="Tallóz"
      class="mb-2"
      style="max-width: 400px;"
      @change="onLogoChange"
    />

    <hr>
    <b-button
      variant="primary"
      :disabled="saving"
      @click="save"
    >
      {{ saving ? 'Mentés...' : 'Mentés' }}
    </b-button>
    <b-button
      variant="outline-secondary"
      class="ml-1"
      @click="$router.push('/client/list')"
    >
      Mégsem
    </b-button>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BFormGroup, BFormInput, BButton, BFormFile,
} from 'bootstrap-vue'
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard, BRow, BCol, BFormGroup, BFormInput, BButton, BFormFile,
  },
  data() {
    return {
      company_name: '',
      phone: '',
      contact_name: '',
      logo_file: null,
      logo_preview: null,
      saving: false,
    }
  },
  methods: {
    onLogoChange(event) {
      const file = event.target.files[0]
      if (file) {
        this.logo_preview = URL.createObjectURL(file)
      }
    },
    save() {
      this.saving = true
      axios({
        method: 'post',
        url: 'client/create',
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        data: {
          company_name: this.company_name,
          phone: this.phone,
          contact_name: this.contact_name,
        },
      }).then(response => {
        const clientId = response.data.id

        if (this.logo_file && clientId) {
          const formData = new FormData()
          formData.append('logo', this.logo_file)
          return axios({
            method: 'post',
            url: `client/${clientId}/logo`,
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
              'Content-Type': 'multipart/form-data',
            },
            data: formData,
          })
        }
        return Promise.resolve()
      }).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: { title: 'Megrendelő létrehozva', icon: 'CheckIcon', variant: 'success' },
        })
        this.$router.push('/client/list')
      }).catch(() => {
        this.$toast({
          component: ToastificationContent,
          props: { title: 'Hiba történt', icon: 'XOctagonIcon', variant: 'danger' },
        })
      })
        .finally(() => {
          this.saving = false
        })
    },
  },
}
</script>
